module.exports = __webpack_public_path__ + "img/51_16.742aefbd.png";